import React, { useState } from "react"
import { EditUserFormTextField } from "./EditUserFormTextField"

interface User {
  id: number
  email: string
}

interface EmailFieldProps {
  user: User
}

export const EmailField: React.FC<EmailFieldProps> = ({ user }) => {
  const [value, setValue] = useState(user.email || "")

  const fieldData = {
    field: "email",
    name: "email",
    label: "Email",
    placeholder: "Enter your email address",
    required: true,
  }

  return (
    <>
      <EditUserFormTextField
        fieldData={fieldData}
        value={value}
        setValue={setValue}
        userId={user.id}
      />
    </>
  )
}
